import h from 'virtual-dom/h';
import { settings } from "../../../../settings/settings-util";


export default class SurveyHeaderBuilder
{
    //#region Public Interface

    constructor(settings, linkBuilder)
    {
        this._settings = settings;
        this._linkBuilder = linkBuilder;
    }

    buildHeader(headerConfig, surveyId)
    {
        const titleClassName = this._settings.classNames.surveyTitle || settings.classNames.surveyTitle;
        const closeClassName = this._settings.classNames.surveyCloseButton || settings.classNames.surveyCloseButton;
        const closeWrapClassName = this._settings.classNames.surveyCloseButtonWrap || settings.classNames.surveyCloseButtonWrap;
        const headerClassName = this._settings.classNames.surveyHeader || settings.classNames.surveyHeader;
        const closeTitle = this._settings.textConstants.surveyCloseTitle;

        const children = [];
        const closeButton = this._linkBuilder.buildLink(headerConfig.CancelLink, closeClassName, closeTitle);

        if (headerConfig.Title)
        {
            children.push(h('div', { className: titleClassName, id: `${surveyId}-title` }, headerConfig.Title));
        }

        if (closeButton)
        {
            children.unshift(h("div", { className: closeWrapClassName }, [closeButton]));
        }

        return h("div", { className: headerClassName }, children);
    }

    //#endregion
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/simple-feedback-overlay/src/builders/surveyHeaderBuilder.js